<div>
  <div class="grid grid-cols-1 md:grid-cols-2 gap-4 items-center py-6 relative">
    <div>
      <h2 class="text-2xl font-semibold text-slate-800 mb-2">User Access</h2>
    </div>
    <div>
      <label class="block text-sm font-semibold text-slate-700 mb-2">
        Select User
      </label>
      <p-dropdown  
        id="userSelect"
        [options]="roles"
        (onChange)="getUserMapping()" 
        filter="true"
        optionLabel="first_name" 
        filterBy="first_name,last_name,hrcdf_designation,loginname,unit.name" 
        [(ngModel)]="selectedRole"
        placeholder="Choose a user"
        appendTo="body"
        styleClass="w-full rounded"
      >
        <ng-template pTemplate="selectedItem" let-user>
          <div *ngIf="user">
            <small>
              #<strong>{{ user.loginname }}</strong> |
              <strong>{{ user.first_name }} {{ user.last_name }}</strong>
            </small>
          </div>
          <div *ngIf="!user" class="text-slate-500">
            Choose a user
          </div>
        </ng-template>
        <!-- Dropdown list items -->
        <ng-template pTemplate="item" let-user>
          <div class="py-1 px-2 hover:bg-slate-100">
            <small>
              #<strong>{{ user.loginname }}</strong> |
              <strong>{{ user.first_name }} {{ user.last_name }}</strong> |
              <strong>{{ user.hrcdf_designation }}</strong>
            </small>
          </div>
        </ng-template>
      </p-dropdown>
    </div>
    <ng-container *ngIf="selectedRole != null">
      <div class="absolute right-0 top-0 md:static md:col-span-2 mt-4 md:mt-0 flex justify-end w-full">
        <button pButton type="button" label="Save Changes" icon="pi pi-save" class="save-changes-btn"
          [disabled]="selectedRole == null" (click)="saveChanges()" *ngIf="'/setup' | hasPermission: 'Add'"></button>
      </div>
    </ng-container>
  </div>
  <!-- Table -->
<div class="table-wrapper" *ngIf="selectedRole != null">

    <p-table [value]="flatModules" 
      [tableStyle]="{ 'min-width': '600px' }">
      <ng-template pTemplate="header">
        <tr>
          <th >Module</th>
          <th *ngFor="let perm of permissions" >{{ perm.name }}</th>
          <th >Enabled</th>
          <th  *ngIf="canEditSetup">Actions</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-module>
        <ng-container *ngTemplateOutlet="recursiveRow; context: { $implicit: module, level: 0 }"></ng-container>
      </ng-template>

      <ng-template #recursiveRow let-module let-level="level">
        <tr>
          <td [ngClass]="'level-' + level" class="bottom-border custom-td">
            {{ module.name }}
            <i *ngIf="module.children && module.children.length > 0" class="pi pointer mw-2" [ngClass]="{
              'pi-chevron-up': expandedMenus.has(module.id),
              'pi-chevron-down': !expandedMenus.has(module.id)
            }" (click)="toggleExpand(module.id)"></i>
            
          </td>
          <td *ngFor="let perm of permissions" class="bottom-border">
            <p-checkbox [(ngModel)]="module.permissions[perm.name]" binary="true" class="custom-checkbox"
              (onChange)="onPermissionChange(module , perm.name)"></p-checkbox>
          </td>
          <td class="bottom-border">
            <p-inputSwitch [(ngModel)]="module.enabled" class="custom-toggle"
              (onChange)="onToggleChange(module)"></p-inputSwitch>
          </td>
          <td class="text-center flex gap-2 justify-center">
            <button
          
             
              pTooltip="Add Sub Menu"
              (click)="openAddMenuDialog(true, module)"
              *ngIf="'/setup' | hasPermission: 'Add' "
              class="rounded border-2 border-violet-400 bg-violet-100 text-violet-600 hover:bg-violet-200 focus:outline-none flex items-center justify-center w-10 h-10 p-0 transition-all"
            >
              <i class="pi pi-plus"></i>
            </button>

            <button
              
             
              pTooltip="Edit Menu"
              (click)="editMenu(module, !!module.parent)"
              *ngIf="'/setup' | hasPermission: 'Edit' "
              class="rounded border-2 border-orange-400 bg-orange-100 text-orange-600 hover:bg-orange-200 focus:outline-none flex items-center justify-center w-10 h-10 p-0 transition-all"
            >
              <i class="pi pi-pencil"></i>
            </button>

            <button
          
              icon="pi pi-trash"
              pTooltip="Delete Menu"
              (click)="deleteMenu(module)"
              *ngIf="'/setup' | hasPermission: 'Delete' "
              class="rounded border-2 border-rose-400 bg-rose-100 text-rose-600 hover:bg-rose-200 focus:outline-none flex items-center justify-center w-10 h-10 p-0 transition-all"
            >
              <i class="pi pi-trash"></i>
          </button>
          </td>
        </tr>
        <ng-container *ngIf="expandedMenus.has(module.id)">
          <ng-container *ngFor="let child of module.children">
            <ng-container
              *ngTemplateOutlet="recursiveRow; context: { $implicit: child, level: level + 1 }"></ng-container>
          </ng-container>
        </ng-container>
      </ng-template>

    </p-table>
  </div>
  <div class="table-wrapper d-flex align-items-center center-aligned" *ngIf="selectedRole == null">
    <h5>Select a user to view privileges.</h5>
  </div>
</div>

 <p-dialog [header]="getDialogHeader()" [(visible)]="showMenuDialog" [modal]="true" [style]="{ width: '400px' }"
  [closable]="true" [maximizable]="true">
  <form [formGroup]="menuForm" (ngSubmit)="saveMenu()">
    <div class="p-fluid mt-4">
      <div class="field mb-3">
        <label for="menuName">Menu Name *</label>
        <input id="menuName" type="text" pInputText formControlName="name" placeholder="Enter menu name" />
        <small *ngIf="menuForm.controls['name'].invalid && menuForm.controls['name'].touched" class="p-error">
          Menu Name is required.
        </small>
      </div>

      <div class="field mb-3">
        <label for="menuUrl">URL</label>
        <input id="menuUrl" type="text" pInputText formControlName="url" placeholder="/" />
      </div>

      <div class="field mb-4">
        <label for="menuIcon">Icon</label>
        <input id="menuIcon" type="text" pInputText formControlName="icon" placeholder="MessageSquare" />
      </div>
      <div class="field mb-3" *ngIf="showParentDropdown">
        <label for="menuParent">Parent</label>
        <p-dropdown id="menuParent" [options]="parentMenuOptions" formControlName="parent" optionLabel="name"
          optionValue="id" placeholder="Select parent (optional)" [filter]="true" filterBy="name">
        </p-dropdown>
      </div>
       <div class="field mb-3" *ngIf="!isSubMenu">
        <p-checkbox inputId="isSchemeMenu" formControlName="isSchemeMenu" binary="true" label="Is scheme menu?">
        </p-checkbox>
      </div>
      <div class="field mb-3" *ngIf="menuForm.get('isSchemeMenu')?.value">
        <label for="schemeId">Select Scheme</label>
        <p-dropdown inputId="scheme" formControlName="scheme" [options]="schemes" [filter]="true" filterBy="name"
          optionLabel="name" placeholder="Select Scheme" [style]="{ 'width': '100%' }" optionValue="id">
        </p-dropdown>
      </div>


      <div class="d-flex justify-content-end gap-2 mt-4">
        <button pButton type="submit" label="Submit" [disabled]="menuForm.invalid" class="fetch-data-btn"></button>
      </div>
    </div>
  </form>
</p-dialog>

<p-dialog [header]="getDialogHeader()" [(visible)]="showEditMenuDialog" [modal]="true" [style]="{ width: '400px' }"
  [closable]="true" [maximizable]="true">
  <form [formGroup]="menuForm" (ngSubmit)="saveEditMenu()">
    <div class="p-fluid mt-4">
      <div class="field mb-3">
        <label for="menuName">Menu Name *</label>
        <input id="menuName" type="text" pInputText formControlName="name" placeholder="Enter menu name" />
        <small *ngIf="menuForm.controls['name'].invalid && menuForm.controls['name'].touched" class="p-error">
          Menu Name is required.
        </small>
      </div>

      <div class="field mb-3">
        <label for="menuUrl">URL</label>
        <input id="menuUrl" type="text" pInputText formControlName="url" placeholder="/" />
      </div>

      <div class="field mb-4">
        <label for="menuIcon">Icon</label>
        <input id="menuIcon" type="text" pInputText formControlName="icon" placeholder="MessageSquare" />
      </div>
      <div class="field mb-3">
        <label for="menuParent">Parent</label>
        <p-dropdown id="menuParent" [options]="parentMenuOptions" formControlName="parent" optionLabel="name"
          optionValue="id" placeholder="Select parent (optional)" [filter]="true" filterBy="name">
        </p-dropdown>
      </div>
 <div class="field mb-3" *ngIf="!isSubMenu">
        <p-checkbox inputId="isSchemeMenu" formControlName="isSchemeMenu" binary="true" label="Is scheme menu?">
        </p-checkbox>
      </div>
      <div class="field mb-3" *ngIf="menuForm.get('isSchemeMenu')?.value">
        <label for="schemeId">Select Scheme</label>
        <p-dropdown inputId="scheme" formControlName="scheme" [options]="schemes" [filter]="true" filterBy="name"
          optionLabel="name" placeholder="Select Scheme" [style]="{ 'width': '100%' }" optionValue="id">
        </p-dropdown>
      </div>

      <div class="d-flex justify-content-end gap-2 mt-4">
        <button pButton type="submit" label="Submit" [disabled]="menuForm.invalid" class="fetch-data-btn"></button>
      </div>
    </div>
  </form>
</p-dialog>

<p-dialog header="Delete Menu" [modal]="true" [(visible)]="showDeleteDialog" [style]="{ width: '30rem' }" [maximizable]="true">
  <div class="delete-dialog">
    <span>Are you sure , you want to delete menu ?</span>
    <p-button label="Delete" icon="pi pi-trash" severity="danger" [outlined]="true" (click)="confirmDelete()">
    </p-button>
  </div>
</p-dialog>